import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
import WildAppResource from "./WildAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import UserAppResource from "./UserAppResource";
import ExternalOfficeAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ExternalOfficeAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";

class ExternalUserAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'external-user';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'externals/users';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'user_uuid',
            'external_id',
            'external_data',
            'connector_uuid',
            'external_name',
            'data',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            connector: WildAppResource,
            organization: OrganizationAppResource,
            user: UserAppResource,
            externalOffices: ExternalOfficeAppResource,
            organizationMemberships: OrganizationMemberAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }
}

export default ExternalUserAppResource;
